
<!-- 监控设备-->
<template>
  <div>
    <x-tabula
      :apiOrigin="apiOrigin"
      ref="table"
      :dataSource="dataSource"
      rowKey="id"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :addHandleParam="addHandleParam"
      :deleteParam="deleteParam"
      :rowSelection="false"
      @resetSearch = "resetSearch"
    >
    </x-tabula>
  </div>
</template>

<script>
import { fetchSelect } from '../../../utils/mixins';
export default {
  mixins: [fetchSelect],
  name: 'monitoringAids',
  data () {
    return {
      apiOrigin: 'PHP',
      searchList: [
        { props: ['community_id'], placeholder: '小区', options: [], inputType: 'select', fetchOptions: this.getOptions },
        { props: ['title'], placeholder: '名称', inputType: 'input' }
      ],
      tableOptList: [
        { text: '新增', permi: ['device:monitor:add'] }
      ],
      rowOptList: [
        { text: '编辑', handle: record => this.$refs.table.toEdit(record), permi: ['device:monitor:edit'] },
        { text: '同步数据', handle: row => this.evetSync(row), permi: ['device:monitor:sync'] },
        { text: '删除', handle: (row) => this.$refs.table.showDeleteConfirm(row), permi: ['device:monitor:delete'] }
      ],
      columns: [
        { title: '小区', dataIndex: 'community_name', align: 'left', width: '' },
        { title: '设备名称', dataIndex: 'title', align: 'left', width: '' },
        { title: '序列号', dataIndex: 'device_sncode', align: 'left', width: '' },
        { title: '连接参数', dataIndex: 'url', align: 'left', width: '' },
        { title: '网络状态', dataIndex: 'status_txt', align: 'left', width: '' },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      searchParams: {
        community_id: undefined,
        title: undefined
      },
      listApi: {
        url: '/aisecurity/watchdogs',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      addHandleParam: {
        route: 'addEquipment',
        title: '编辑设备'
      },
      deleteParam: {
        url: '/aisecurity/watchdogs',
        param: {pk_key: 'id', pk_val: ''},
        title: '监控设备',
        key: 'title'
      }
    };
  },
  mounted () {
    // this.communitySelect(0, 'searchList', 1);
    this.communitySelectByStep(1, undefined, 'searchList', '0');
  },
  methods: {
    resetSearch () {
      this.communitySelectByStep(undefined, undefined, 'searchList', '0');
      this.searchList[0].searchValue = undefined;
    },
    getOptions (pageNum, search) {
      return this.communitySelectByStep(pageNum, search, 'searchList', '0');
    },
    evetSync (row) {
      this._post({
        url: '/aisecurity/watchdogs/syndata',
        params: {
          id: row.id
        }
      }).then(res => {
        this.$message.success(res.msg);
      });
    },
    resHandle (res) {
      console.log('处理list返回数据: ');
      return res;
    },
    searchHandle (selectData) {
      console.log('处理搜索数据: ', selectData);
      // return selectData;
    }
  }
};
</script>

<style scoped>
.pic-box {
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  cursor: pointer;
}
img {
  height: auto;
  width: 100%;
}
</style>
